module.exports = __webpack_public_path__ + "img/main-window.4fdbd02d.png";